import React from "react";

const ErrorState = ({ error }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem",
      backgroundColor: "#f8d7da",
      borderRadius: "0.5rem",
      border: "1px solid #f5c2c7",
      maxWidth: "600px",
      margin: "0 auto",
    }}
  >
    <h2
      style={{
        color: "#842029",
        fontSize: "1.5rem",
        marginBottom: "1rem",
        fontWeight: "bold",
      }}
    >
      Error
    </h2>
    <p
      style={{
        color: "#842029",
        marginBottom: "1.5rem",
        textAlign: "center",
      }}
    >
      {error}
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{
        marginTop: "1rem",
        backgroundColor: "#dc3545",
        color: "white",
        padding: "0.5rem 1rem",
        borderRadius: "0.25rem",
        border: "none",
        cursor: "pointer",
        fontSize: "1rem",
        fontWeight: "500",
        transition: "background-color 0.15s ease-in-out",
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#bb2d3b")}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#dc3545")}
    >
      Try Again
    </button>
  </div>
);

export default ErrorState;
